export default {

	//Session status
	CANCELLED: 0,
	RELEASE: 2,
	TOVALIDATE: 3,
	BLOCKED: 4,
	TOEVALUATE: 5,
	CLOSED: 6,
	DRAFT: 7,
	ONHOLD: 8,
	CONFIRMED: 9,
	TOCONTROL: 10,

	//Group roles
	COORDINATION: 1,
	TRAINER: 2,

	//Session types
	EVENTS: 1,
	ADULTS: 2,
	SCHOOL: 3,
	TEACHERS: 4,
	YOUTH: 5,
	OTHER: 6,
	INTERNAL: 7,
	FREELANCES_TRAINING: 8,
	ACTIVITY: 9,
	INTRODUCTION_DAY: 10,
	INTERNAL_AS: 11,
	FREELANCES_REFRESH_TRAINING: 12,

	//Internal types
	INTERNALTRAINER: '1',
	INTERNALSTUDENT: '2',

	//Internal AS types
	INTERNAL_AS_REVIEW: '1',
	INTERNAL_AS_WG: '2',
	INTERNAL_AS_STUFF: '3',

	APPLICATION: {
		ALL: 0,
		BEESECURE: 1,
		FREELANCES: 2
	},

	SKILL_ROLE: {
		TRAINING: 0,
		TEACHER: 1,
		INTERN: 2,
		SPECIALIZED_ANIMATOR: 3,
		EXPERT: 4,
		BS_CANDIDATE: 5,
		BS_TRAINER: 6,
	},

	ANIMATOR_ROLE: {
		TEACHER: 1,
		SPECIALIZED: 2,
		MIXED: 3
	},
	FIELD_TYPES: {
		SIMPLE_TEXT: 1,
		LONG_TEXT: 2,
		DATE: 3,
		EMAIL: 4,
		NUMBER: 5,
		SINGLE_CHOICE: 6,
		MULTIPLE_CHOICES: 7,
		RADIO_GROUP: 8,
		SEPARATOR: 9
	},
	FIELD_DEFAULTS_VALUE: {
		NAME: 'Please fill in the label of the new field here...',
		TIP: 'You can write a tip that will describe the field and its expectations here ...'
	},
	EVAL_TARGETS: {
		"1": "simple_text_value",
		"2": "long_text_value",
		"3": "number_value",
		"4": "date_value",
		"5": "single_choice_id",
		"6": null,
		"7": null,
	},
	GROUPS_TYPES: {
		CYCLE: 1,
		AGES: 2
	},
	TOPIC_EXCEPTIONS: {
		D2D: 1,
		WD: 2
	},
	EVALUATIONS_TYPES: {
		DAGGESRAPPORT_TRAINING: 1,
		DAGGESRAPPORT_ACTIVITY: 2,
		EVALUATION_TRAINING: 3,
		EVALUATION_ACTIVITY: 4,
		EVALUATION_INTERN: 5,
		BS_DAGGESRAPPORT_TRAINING: 6,
		BS_EVALUATION_TRAINER: 7,
		BS_EVALUATION_TEACHER: 8
	},
	INDEMNITIES_STATUS: {
		DRAFT: 1,
		IN_PROGRESS: 2,
		PUBLISHED: 3,
	},
	BATCHES_STATUS: {
		WAITING: 1,
		PROCESSING: 2,
		FINISHED: 3,
	}
}

